import {NgModule} from '@angular/core';
import {SharedModule} from '@helpers/modules/shared.module';
import {ObjectsListComponent} from './objects-list/objects-list.component';
import {ObjectViewComponent} from './object-view/object-view.component';
import {ObjectFormComponent} from './object-form/object-form.component';
import {DirectivesModule} from '@helpers/directives/directives.module';
import {FilesUploaderModule} from '@components/files-uploader/files-uploader.module';
import {StaffListComponent} from './subpages/staff-list/staff-list.component';
import {EquipmentListComponent} from './subpages/equipment-list/equipment-list.component';
import {EquipmentCardModule} from '@modules/equipment-card/equipment-card.module';
import {PagingControlModule} from '@components/paging-control/paging-control.module';
import {SpecialistsModule} from '@modules/specialists/specialists.module';
import {WorkingObjectsResolver} from './services/working-objects.resolver';
import {BlankObjectsApiService} from './services/blank-objects.api.service';
import {BlankWorkingObjectResolver} from './services/blank-working-object.resolver';
import {WorkingObjectSpecialistsResolver} from './services/working-object-specialists.resolver';
import {ObjectsSetStatusFormComponent} from './objects-set-status-form/objects-set-status-form.component';
import {ReactiveFormsModule} from '@angular/forms';
import {ObjectsSetStatusApiService} from './services/objects-set-status.api.service';
import {TechnicalDeviceListComponent} from './subpages/technical-device-list/technical-device-list.component';
import {WorkingObjectsFiltersComponent} from './components/working-objects-filters/working-objects-filters.component';
import {WorkingObjectPagesService} from './services/working-object-pages.service';
import {FilteredWorkingObjectsResolver} from './services/filtered-working-objects.resolver';
import {WorkingObjectsPagesResetOnDeactivateService} from './services/working-objects-pages-reset-on-deactivate.service';
import {WorkingObjectTechnicalDevicePagesService} from './services/working-object-technical-device-pages.service';
import {FilteredTechnicalDevicesResolver} from './services/filtered-technical-devices.resolver';
import { TechnicalDeviceListItemComponent } from './components/technical-device-list-item/technical-device-list-item.component';
import {WorkingObjectsTechnicalDevicePagesResetOnDeactivateService} from './services/working-objects-technical-device-pages-reset-on-deactivate.service';
import {EquipmentListPagesService} from './services/equipment-list/equipment-list-pages.service';
import {EquipmentListPagesResolver} from './services/equipment-list/equipment-list-pages.resolver';
import {IconsModule} from '@lab365/icons';

@NgModule({
    imports: [
        SharedModule,
        DirectivesModule,
        FilesUploaderModule,
        EquipmentCardModule,
        SpecialistsModule,
        PagingControlModule,
        ReactiveFormsModule,
        IconsModule,
    ],
    exports: [],
    declarations: [
        ObjectsListComponent,
        ObjectViewComponent,
        ObjectFormComponent,
        StaffListComponent,
        EquipmentListComponent,
        TechnicalDeviceListComponent,
        ObjectsSetStatusFormComponent,
        WorkingObjectsFiltersComponent,
        TechnicalDeviceListItemComponent,
    ],
    providers: [
        ObjectsSetStatusApiService,
        BlankObjectsApiService,
        BlankWorkingObjectResolver,
        WorkingObjectsResolver,
        WorkingObjectSpecialistsResolver,

        WorkingObjectPagesService,
        FilteredWorkingObjectsResolver,
        WorkingObjectsPagesResetOnDeactivateService,

        WorkingObjectTechnicalDevicePagesService,
        FilteredTechnicalDevicesResolver,
        WorkingObjectsTechnicalDevicePagesResetOnDeactivateService,

        EquipmentListPagesService,
        EquipmentListPagesResolver,
    ],
})
export class ObjectsModule {
}
